import script from "./BaseInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseInput.vue?vue&type=script&setup=true&lang=ts"

import "./BaseInput.vue?vue&type=style&index=0&id=c0d481b6&scoped=true&lang=css"

import exportComponent from "E:\\salekWebApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0d481b6"]])

export default __exports__